var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M7.69 5.19L8.273 3h7.454l.583 2.19h5.28c1.056 0 1.91.872 1.91 1.95v11.812c0 1.075-.854 2.048-1.903 2.048H2.403C1.35 21 .5 20.127.5 19.049V7.238c0-1.078.854-1.952 1.91-1.952l5.28-.097z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 4,
    stroke: props.color
  }));
}
export default SvgIconCamera;